import Container from "../../../../components/container";
import Icon from "../../../../components/icon";
import { GreetingOccasionCategory } from "../../../../models";
import { GreetingOccasionCategoryViewModel } from "../../../../viewModels";
import { DeleteGreetingOccasionCategory, UpdateGreetingOccasionCategory } from "./buttons";
import GreetingOccasionSubcategoriesTable from "./greeting-occasion-subcategories-table";

export default function GreetingOccasionCategoriesTable({
  greetingOccasionCategories,
}: {
  greetingOccasionCategories: GreetingOccasionCategoryViewModel[];
}) {
  return (
    <Container className=" max-w-xl">
      {/* Mobile layout */}
      <div className="lg:hidden">
        {greetingOccasionCategories?.map((greetingOccasionCategory) => (
          <div
            key={greetingOccasionCategory.id}
            className="mb-4 w-full rounded-md bg-white p-4"
          >
            <h2 className="text-lg font-semibold">{greetingOccasionCategory.name}</h2>            
            <div className="flex items-center justify-between pb-4 mt-2">
              {greetingOccasionCategory.id ? (
                <div className="w-full flex items-center justify-center gap-2">
                  <UpdateGreetingOccasionCategory id={greetingOccasionCategory.id.toString()} />
                  <DeleteGreetingOccasionCategory id={greetingOccasionCategory.id.toString()} />
                </div>
              ) : null}
            </div>
           
          </div>
        ))}
      </div>

      {/* Desktop table */}
      <table className="hidden min-w-full text-gray-900 text-left lg:table">
        <thead className="rounded-lg text-left text-sm font-normal">
          <tr>            
            <th className="px-6 py-3">Name</th>
            <th className="px-6 py-3 "></th>
          </tr>
        </thead>
        <tbody className="bg-white">
          {greetingOccasionCategories.map((greetingOccasionCategory) => (
            <>
              <tr key={greetingOccasionCategory.id} className="border-b">              
                <td className="px-6 py-4 font-medium">{greetingOccasionCategory.name}</td>
                <td className="px-6 py-4">
                  {greetingOccasionCategory.id ? (
                    <div className="flex items-center justify-end gap-2">
                      <UpdateGreetingOccasionCategory id={greetingOccasionCategory.id.toString()} />
                      <DeleteGreetingOccasionCategory id={greetingOccasionCategory.id.toString()} />
                    </div>
                  ) : null}
                </td>
              </tr>              
            </>
          ))}
        </tbody>
      </table>
    </Container>
  );
}

